import { memo, useCallback } from 'react';
import { Box, Button } from '@mui/material';
import { FormSpy } from 'react-final-form';

// ─────────────────────────────────────────────────────────────────────────────
// Reset button cluster ────────────────────────────────────────────────────────
// ─────────────────────────────────────────────────────────────────────────────
export const StepperResetButtons = memo(({ dispatch }) => {
  const handleReset = useCallback(() => dispatch({ type: 'RESET' }), [dispatch]);

  return (
    <Box mt={1} px={2} pb={2} display="flex" justifyContent="flex-end">
      <Button onClick={handleReset}>Reset</Button>
    </Box>
  );
});

// ─────────────────────────────────────────────────────────────────────────────
// Main stepper navigation ─────────────────────────────────────────────────────
// ─────────────────────────────────────────────────────────────────────────────
const StepperButtons = memo(({ stepperState: { activeStep }, stepCount, dispatch, optional = false }) => {
  const handleBack = useCallback(() => dispatch({ type: 'BACK' }), [dispatch]);
  const handleSkip = useCallback(() => dispatch({ type: 'SKIP' }), [dispatch]);

  return (
    <Box mt={1} px={2} pb={2} display="flex" justifyContent="flex-end" gap={1}>
      <Button disabled={activeStep === 0} onClick={handleBack} style={{ color: 'black'}}>
        Back
      </Button>

      {optional && (
        <Button variant="contained" color="primary" onClick={handleSkip} style={{ color: 'black'}}>
          Skip
        </Button>
      )}

      <FormSpy subscription={{ submitting: true }}>
        {({ submitting }) => (
          <Button
            type="submit"
            variant="contained"
            disabled={submitting}
            style={{ backgroundColor: '#9aeeda', color: 'black' }}
          >
            {activeStep === stepCount - 1 ? 'Finish' : 'Next'}
          </Button>
        )}
      </FormSpy>
    </Box>
  );
});

export default StepperButtons;
